import React, { useState } from "react";
import Layout from "../form-layout";
import DoseSelector from "./dose-selector";
import { GLP1_MEDICATIONS } from "../../data/eligibility-rules";

// Q15 — "What is your current or most recent weekly dose?" Dose options shown depend
// on the medication picked in Q13.
export default function Step15({ formData, setFormData, onBack, goToStep }) {
  const medication = GLP1_MEDICATIONS.find((m) => m.key === formData.glp1TriedMedication);
  const [dose, setDose] = useState(formData.glp1FollowupDose || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (medication?.doseOptions?.length && !dose) return;

    setFormData((prev) => ({ ...prev, glp1FollowupDose: dose }));
    localStorage.setItem("glp1FollowupDose", dose);

    goToStep("16");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        What is your current or most recent weekly dose?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <DoseSelector doseOptions={medication?.doseOptions} selected={dose} onSelect={setDose} />

        <div className="flex justify-start mt-2">
          <button
            type="submit"
            disabled={Boolean(medication?.doseOptions?.length) && !dose}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                Boolean(medication?.doseOptions?.length) && !dose
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
